import { useState } from "react"
import { Link } from "react-router-dom";
import DeleteModal from '../cors/DeleteModal'; 
import { BASE_URL } from '../apiConfig';
import { toast } from 'sonner';
import { useAuth } from "../context/AuthProvider";

export default function CategoryCard({ role, category, fetchCategories }) {
  const [imageError, setImageError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { token, roles } = useAuth();

  const deleteCategory = async () => {
    setIsModalOpen(false); 

    try {
      const res = await fetch(BASE_URL+`/api/categories/${category.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success("Delete reussi");
        fetchCategories();
      } else {
        toast.error("Delete failed");
      }
    } catch (error) {
      toast.error("Delete failed");
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  return (
    <div className="group mx-auto w-full min-2xl:w-full bg-white bg-red-500 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
      <Link to={`/products?category=${category.slug}`} >
        <div className="relative overflow-hidden">
          <div className="aspect-video relative bg-gradient-to-br from-[var(--color-primary-50)] via-white to-gray-100">
            {!imageError && category.image ? (
              <img
                src={`${BASE_URL}/storage/${category.image}`}
                alt={category.title}
                fill
                unoptimized 
                className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="flex items-center justify-center h-full">
                <svg className="h-10 w-10 text-[var(--color-primary-100)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
            )}
          </div>

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

          {/* Item Count Badge */}
          <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm text-[var(--color-primary-500)] px-3 py-1 rounded-full text-[10px] font-semibold shadow-lg">
            {category.count} items
          </div>
        </div>
      </Link>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-bold text-gray-900 mb-3 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
          {category.title}
        </h3>

        <div className="flex items-center text-[10px] text-gray-500 mb-4">
          <svg className="h-3.5 w-3.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          Dernière mise à jour: {formatDate(category.updated_at)}
        </div>

        <div className="flex justify-end gap-2">
          {
            (role === 1 || (role === 2 && roles.edit_category === 1)) &&
              <Link to={`/categories/update/${category.id}`}>
              <button className="p-2 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
                <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </Link>
          }
          {
            (role === 1 || (role === 2 && roles.delete_category === 1)) &&
            <button
                onClick={() => setIsModalOpen(true)} 
                className="p-2 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
            >
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2
                  2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
                  1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                />
              </svg>
            </button>
          }
        </div>
      </div>
      
      {
        isModalOpen &&
          <DeleteModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onConfirm={deleteCategory}
              title="Delete Category"
              message="Are you sure you want to delete the category?"
              itemName={category.name}
            />
      }
    </div>
  )
}
